export const maintenanceWorkflowsTableColumns = [
  { value: 'status', label: 'Status' },
  { value: 'current_forwarding', label: 'Encaminhamento atual' },
  { value: 'process_id', label: 'ID do Processo' },
  { value: 'company', label: 'Empresa' },
  { value: 'equipment', label: 'Equipamento' },
  { value: 'actions', label: 'Ações', className: 'w-11' },
];
